import * as React from 'react'
import Header from './header'
import Footer from './footer'
import Message from './message'
import { connect } from 'react-redux'
import StatusActions from '../modules/status/status-actions'
import Spinner from './spinner'
import CurrentProgress from './current-progress'
import './shell.css'


class Shell extends React.Component<any, any>{

   
    render(){
        const message = this.props.message;

        return (
            <div className="shell">
                <CurrentProgress />
                { this.props.children }
            </div>
        )

    }

}


const mapStateToProps = state => ({
    message: state.status.message,
    status: state.status
})


const mapDispatchToProps = (dispatch) => ({
    actions:{
        hideMessage: () => dispatch( StatusActions.hideMessage() )
    }
})


export default connect(mapStateToProps, mapDispatchToProps)(Shell)




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/shell.tsx